<div class="container-fluid p-0">
  <header>
    <a class="text-decoration-none" (click)="logoClick()">
      <img src="./../../../assets/logo.png" alt="Logo" width="50" height="35" class="d-inline-block align-text-top">
      <label class="logo-text">Trade Journaling</label>
    </a>
  </header>
  <ng-content select="[body]"></ng-content>
</div>
